/**
 * Minimal D2C Product Personalization Script
 * Handles single name input, live text preview, and validation
 */

document.addEventListener('DOMContentLoaded', () => {
  initD2CPersonalizer();
});

function initD2CPersonalizer() {
  const nameInput = document.querySelector('#custom-engraving-name');
  const previewName = document.querySelector('#preview-engrave-name');
  const charCounter = document.querySelector('#engrave-char-counter');
  const photoInput = document.querySelector('#custom-photo-file');
  const photoPreview = document.querySelector('#preview-photo-thumb');
  const form = document.querySelector('form[action*="/cart/add"]');
  const maxChars = nameInput ? (parseInt(nameInput.getAttribute('maxlength')) || 12) : 12;

  // 1. Live Name Input & Uppercase auto-format
  if (nameInput && previewName) {
    nameInput.addEventListener('input', (e) => {
      let val = e.target.value.toUpperCase();
      nameInput.value = val; // enforce uppercase for precision laser look

      if (val.trim() === '') {
        previewName.textContent = previewName.dataset.default || 'YOUR NAME';
        previewName.style.opacity = '0.5';
      } else {
        previewName.textContent = val;
        previewName.style.opacity = '1';
      }

      if (charCounter) {
        charCounter.textContent = `${val.length}/${maxChars} chars`;
      }
    });
  }

  // 2. Photo upload preview (for frames/mugs)
  if (photoInput && photoPreview) {
    photoInput.addEventListener('change', function() {
      const file = this.files[0];
      if (file) {
        if (file.size > 10 * 1024 * 1024) {
          alert('Please select an image under 10MB.');
          this.value = '';
          return;
        }
        const reader = new FileReader();
        reader.onload = function(e) {
          photoPreview.src = e.target.result;
          photoPreview.style.display = 'block';
        };
        reader.readAsDataURL(file);
      }
    });
  }

  // 3. Form Validation before submit
  if (form && nameInput) {
    form.addEventListener('submit', (e) => {
      if (nameInput.hasAttribute('required') && !nameInput.value.trim()) {
        e.preventDefault();
        alert('Please enter a name for personalization.');
        nameInput.focus();
        return false;
      }
    });
  }
}
